import PropTypes from 'prop-types';
import featImage from '../../images/get-your-data.png';
import TrackImage from '../../images/track.inline.svg';
import BellImage from '../../images/bell.inline.svg';
import InfoImage from '../../images/information.inline.svg';
import PinImage from '../../images/pin_location.inline.svg';
import ChartsImage from '../../images/charts.inline.svg';

const GetYourData = ({ thirdRowText, orgType }) => {
	return (
		<div className="section get-your-data">
			<div className="section__content get-your-data__content">
				<div className="get-your-data__image-wrapper">
					<img alt="" className="get-your-data__image" src={featImage} />
				</div>
				<div className="get-your-data__body">
					<h2 className="typography typography--h2 typography--secondary get-your-data__title">
						Get your data, in real time
					</h2>
					<p className="typography typography--subtle-big get-your-data__content">
						Covid Clinic provides a data dashboard to view testing numbers and
						extract meaningful insights as they happen.
					</p>
					<h3 className="typography typography--h5 typography--secondary get-your-data__subtitle">
						Dashboard features
					</h3>
					<ul className="typography typography--body-big typography--tertiary get-your-data__list">
						<li className="get-your-data__list-item">
							<figure className="get-your-data__list-item-icon">
								<TrackImage />
							</figure>
							Track symptoms, tests, and vaccinations
						</li>
						<li className="get-your-data__list-item">
							<figure className="get-your-data__list-item-icon">
								<BellImage />
							</figure>
							Real time data and notifications on cases and contacts
						</li>
						<li className="get-your-data__list-item">
							<figure className="get-your-data__list-item-icon">
								{orgType === 'education' ? <InfoImage /> : <PinImage />}
							</figure>
							{thirdRowText}
						</li>
						<li className="get-your-data__list-item">
							<figure className="get-your-data__list-item-icon">
								<ChartsImage />
							</figure>
							Extract insights and measure trends
						</li>
					</ul>
				</div>
			</div>
		</div>
	);
};

GetYourData.propTypes = {
	thirdRowText: PropTypes.string,
	orgType: PropTypes.string,
};

export default GetYourData;
